<template>
    <div class="container-fluid">
        <form
            class="form"
            @submit.prevent="updateCustomer()"
        >
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <h4>Customer details</h4>

                            <div class="form-group">
                                <label for="company_name">Company name:</label>
                                <input
                                    id="company_name"
                                    v-model="customer.company_name"
                                    type="text"
                                    placeholder="Company name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.company_name }"
                                >
                                <error
                                    name="company_name"
                                    :errors="errors"
                                />
                            </div>

                            <div class="form-group">
                                <label for="account_ref">Account reference:</label>
                                <input
                                    id="account_ref"
                                    v-model="customer.account_ref"
                                    type="text"
                                    placeholder="Account ref."
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.account_ref }"
                                >
                                <error
                                    name="account_ref"
                                    :errors="errors"
                                />
                            </div>

                            <div class="form-group">
                                <label for="billing_name">Billing contact name:</label>
                                <input
                                    id="billing_name"
                                    v-model="customer.billing_name"
                                    type="text"
                                    placeholder="Billing contact name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.billing_name }"
                                >
                                <error
                                    name="billing_name"
                                    :errors="errors"
                                />
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-6">
                                    <label for="billing_email">Billing email:</label>
                                    <input
                                        id="billing_email"
                                        v-model="customer.billing_email"
                                        type="email"
                                        placeholder="Billing email"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.billing_email }"
                                    >
                                    <error
                                        name="billing_email"
                                        :errors="errors"
                                    />
                                </div>
                                <div class="form-group col-sm-6">
                                    <label for="billing_telephone">Billing telephone:</label>
                                    <input
                                        id="billing_telephone"
                                        v-model="customer.billing_telephone"
                                        type="text"
                                        placeholder="Billing telephone"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.billing_telephone }"
                                    >
                                    <error
                                        name="billing_telephone"
                                        :errors="errors"
                                    />
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="responsible_person_name">Responsible person name:</label>
                                <input
                                    id="responsible_person_name"
                                    v-model="customer.responsible_person_name"
                                    type="text"
                                    placeholder="Responsible person name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.responsible_person_name }"
                                >
                                <error
                                    name="responsible_person_name"
                                    :errors="errors"
                                />
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-6">
                                    <label for="responsible_person_email">Responsible person email:</label>
                                    <input
                                        id="responsible_person_email"
                                        v-model="customer.responsible_person_email"
                                        type="email"
                                        placeholder="Billing email"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.responsible_person_email }"
                                    >
                                    <error
                                        name="responsible_person_email"
                                        :errors="errors"
                                    />
                                </div>
                                <div class="form-group col-sm-6">
                                    <label for="responsible_person_telephone">Responsible person telephone:</label>
                                    <input
                                        id="responsible_person_telephone"
                                        v-model="customer.responsible_person_telephone"
                                        type="text"
                                        placeholder="Responsible person telephone"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.responsible_person_telephone }"
                                    >
                                    <error
                                        name="billing_telephone"
                                        :errors="errors"
                                    />
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-6">
                                    <label for="response_time_hours">Response Time (hours):</label>
                                    <select
                                        id="response_time_hours"
                                        v-model="customer.response_time_hours"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.response_time_hours }"
                                    >
                                        <option :value="8">
                                            8 hours
                                        </option>
                                        <option :value="4">
                                            4 hours
                                        </option>
                                        <option :value="2">
                                            2 hours
                                        </option>
                                    </select>
                                    <error
                                        name="response_time_hours"
                                        :errors="errors"
                                    />
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-6">
                                    <label for="overdue">Account Overdue:</label>
                                    <input
                                        v-model="customer.overdue"
                                        type="checkbox"
                                    >
                                    <error
                                        name="overdue"
                                        :errors="errors"
                                    />
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-6">
                                    <label for="overdue">Account Proforma/Cash:</label>
                                    <input
                                        v-model="customer.proforma"
                                        type="checkbox"
                                    >
                                    <error
                                        name="proforma"
                                        :errors="errors"
                                    />
                                </div>
                            </div>

                            <hr>

                            <div class="form-group">
                                <button
                                    type="submit"
                                    class="btn btn-primary"
                                >
                                    Save
                                </button>
                                <button
                                    v-if="isOffice"
                                    type="button"
                                    class="btn btn-outline-danger"
                                    @click="confirmDelete"
                                >
                                    <i class="fa fa-times" /> Delete
                                </button>
                                <activity-log
                                    v-if="customer.id"
                                    :id="customer.id"
                                    model="Customer"
                                />
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    @click="$router.go(-1)"
                                >
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <h4>Customer Billing Address</h4>
                            <address-form
                                :address="customer"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <b-modal
            ref="updatedModal"
            title="Saved"
            :ok-only="true"
            @ok="closeModal"
        >
            <p>Customer saved successfully</p>
        </b-modal>
        <delete-customer
            ref="deleteModals"
            :customer="customer"
        />
        <error-modal
            ref="errorModal"
            :action="errorClose"
        />
    </div>
</template>

<script>
import CustomerService from "../../../services/CustomerService";
import DeleteComponent from "./DeleteComponent.vue";
import AddressForm from "../AddressForm.vue";
import ErrorModal from "../../modals/ErrorComponent.vue";
import RouteMixin from '../../../mixins/RouterBaseMixin';
import UsesErrors from "../../../mixins/UsesErrors";

export default {

    components: {
        "delete-customer": DeleteComponent,
        ErrorModal,
        AddressForm
    },
    mixins: [
        RouteMixin,
        UsesErrors,
    ],

    data: function () {
        return {
            customer: {},
            customerService: CustomerService,
            autocomplete: null
        };
    },

    mounted: function () {
        this.initAutocomplete();
        this.customerService.get(this.$route.params.id).then(
            xhr => {
                this.customer = xhr.data;
                window.metaTitle('Edit Customer | ' + this.customer.company_name);
            },
            error => {
                this.$refs.ErrorModal.show(error);
            }
        );
    },

    methods: {
        updateCustomer: function () {
            this.clearErrors();
            this.customerService.update(this.customer).then(
                () => {
                    this.showModal();
                },
                error => {
                    this.captureRequestErrors(error);
                    if (!error.response.data.errors) {
                        this.$refs.errorModal.show(error);
                    }
                }
            );
        },

        showModal: function () {
            this.$refs.updatedModal.show();
        },

        closeModal: function () {
            this.$refs.updatedModal.hide();
            this.$router.push({
                name: this.routeBase + '.customers.show',
                params: {id: this.customer.id}
            });
        },

        confirmDelete: function () {
            this.$refs.deleteModals.show();
        },

        deleteCustomer: function () {
            this.customerService.delete(this.customer).then(
                () => {
                    this.$router.push({name: this.routeBase + '.customer.search', query: {deleted: "true"}});
                }
            );
        },

        geolocate: function () {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    var geolocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    var circle = new window.google.maps.Circle({
                        center: geolocation,
                        radius: position.coords.accuracy
                    });
                    this.autocomplete.setBounds(circle.getBounds());
                });
            }
        },

        initAutocomplete: function () {
            this.autocomplete = new window.google.maps.places.Autocomplete(
                document.getElementById("find_address"),
                {types: ["geocode"]}
            );
            this.autocomplete.addListener("place_changed", () => {
                this.fillAddress();
            });
        },

        fillAddress: function () {
            let place = this.autocomplete.getPlace();
            let address = {};
            if (place.address_components) {
                for (let line_no in place.address_components) {
                    var line = place.address_components[line_no];
                    address[line.types[0]] = line.long_name;
                }
                this.customer.address_line_1 =
                    address.street_number + " " + address.route;
                this.customer.address_line_2 = address.locality;
                this.customer.address_line_3 = "";
                this.customer.town = address.postal_town;
                this.customer.region = address.administrative_area_level_2;
                this.customer.country = address.country;
                this.customer.postcode = address.postal_code;
                if (place.geometry.location) {
                    this.customer.lat = place.geometry.location.lat();
                    this.customer.lng = place.geometry.location.lng();
                }
            }
        },

        errorClose: function () {
            this.$router.push({name: this.routeBase + '.customer.search'});
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/customers/EditComponent.vue